import React from 'react';
import styled from 'styled-components/macro';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const Wrapper = styled('div')<any>`
  margin-top: 45px;
`;

const KPILoader = (): JSX.Element => (
  <Wrapper>
    <ContentLoader width={375} height={90}>
      <rect width="60" height="15" x="20" y="0" />
      <rect width="80" height="15" x="90" y="0" />
      <>
        <rect width="75" height="15" x="20" y="35" />
        <rect width="80" height="15" x="105" y="35" />
      </>
      <>
        <rect width="15" height="15" x="0" y="70" />
        <rect width="80" height="15" x="20" y="70" />
        <rect width="80" height="15" x="110" y="70" />
      </>
    </ContentLoader>
  </Wrapper>
);

export default KPILoader;
